import { Button, ButtonProps } from '@chakra-ui/react';
import IconArrowNext from 'assets/icons/icon-arrow-next.svg?react';

type Props = ButtonProps & {
  hideIcon?: boolean
};

export default function SubmitButton({ hideIcon, ...props }: Props) {
  if (!hideIcon)
    props = {...props, rightIcon: <IconArrowNext /> }
  return (
    <Button
      variant="primary"
      type="submit"
      ml="auto"
      {...props}
    />
  )
}
